import 'css-chunksrc/client/pages/milestonePage/timestamp/styles.scss';export default {
  "timestamp": "_timestamp_1p9i1_1",
  "dates": "_dates_1p9i1_6",
  "row": "_row_1p9i1_10",
  "date": "_date_1p9i1_6"
};